export const GENERIC_QUERIES = {
  search: 'q',
  page: 'page',
  sort: 'sort',
};

export const CADASTRO_QUERIES = {
  createdFrom: 'created-from',
  createdBefore: 'created-before',
  prefixo: 'prefixo',
  nrocontrole: 'nrocontrole',
  nomelote: 'nomelote',
  idlocal: 'idlocal',
  nomeproducao: 'nomeproducao',
};


export const PRODUTO_QUERIES = {
  createdFrom: 'created-from',
  createdBefore: 'created-before',
  codigopessoa: 'codigopessoa',
};

export const PESQUISA_QUERIES = {
  createdFrom: 'created-from',
  createdBefore: 'created-before',
  codigopessoa: 'codigopessoa',
};

export const PESQUISA_CADASTRO_CLIENTE_QUERIES = {
  createdFrom: 'created-from',
  createdBefore: 'created-before',
  codigopessoa: 'codigopessoa',
};

export const CADASTRO_PEDIDO_PRODUTO_QUERIES = {
  createdFrom: 'created-from',
  createdBefore: 'created-before',
  codigopessoa: 'codigopessoa',
};

export const HOME_QUERIES = {
  createdFrom: 'created-from',
  createdBefore: 'created-before',
};